// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__balance {
  cursor: pointer;
  height: 30px;
  display: flex;
  background: #171515;
  border-radius: 24px;
  padding: 5px 8px;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
}
.__balance ._refresh_balance {
  height: 0px;
  width: 0px;
  transition: all 0.2s ease-in;
}
.__balance ._refresh_balance .refresh__ {
  display: none;
  transition: display 0.2s ease-in;
}
@media (max-width: 576px) {
  .__balance ._refresh_balance {
    display: none;
  }
  .__balance .__other_balance {
    display: none;
  }
  .__balance .__balance_divider {
    display: none;
  }
}
.__balance ._increase {
  height: 30px;
  width: 30px;
  display: flex;
}
.__balance ._increase .refresh__ {
  display: block;
}
.__balance:hover {
  background-color: #171515;
}
.__balance:hover .__balance_divider {
  border-color: #676767;
}
.__balance p {
  font-weight: bold;
  font-size: 14px;
  margin-left: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/Balance/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AAzBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA2BF;AAzBE;EAEE,WAAA;EACA,UAAA;EACA,4BAAA;AA0BJ;AAxBI;EACE,aAAA;EACA,gCAAA;AA0BN;ADXE;ECvBA;IAYI,aAAA;EA0BJ;EAtBA;IAEI,aAAA;EAyBJ;EArBA;IAEI,aAAA;EAwBJ;AATF;AAXE;EACE,YAAA;EACA,WAAA;EACA,aAAA;AAuBJ;AArBI;EACE,cAAA;AAuBN;AAnBE;EACC,yBAAA;AAqBH;AAlBI;EACE,qBAAA;AAoBN;AAhBE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAkBJ","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/colors\";\n@import \"./../../styles/mixins\";\n\n.__balance {\n  cursor: pointer;\n  height: 30px;\n  display: flex;\n  background: #171515;\n  border-radius: 24px;\n  padding: 5px 8px;\n  align-items: center;\n  margin-left: 10px;\n  margin-right: 10px;\n\n  ._refresh_balance {\n\n    height: 0px;\n    width: 0px;\n    transition: all 0.2s ease-in;\n\n    .refresh__ {\n      display: none;\n      transition: display 0.2s ease-in;\n    }\n\n    @include sm {\n      display: none;\n    }\n  }\n\n  .__other_balance {\n    @include sm {\n      display: none;\n    }\n  }\n\n  .__balance_divider {\n    @include sm {\n      display: none;\n    }\n  }\n\n  ._increase {\n    height: 30px;\n    width: 30px;\n    display: flex;\n\n    .refresh__ {\n      display: block;\n    }\n  }\n\n  &:hover {\n   background-color: #171515;\n\n\n    .__balance_divider {\n      border-color: #676767;\n    }\n  }\n\n  p {\n    font-weight: bold;\n    font-size: 14px;\n    margin-left: 5px;\n    cursor: pointer;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
